import React, { useState } from "react";
import { TextField, FormControl, Box } from "@material-ui/core";
import * as Constants from "../../Constants/Styles";

const Search = (props) => {
  const classes = Constants.useStyles();
  const onChangeHandler = (event) => {
    props.onChangeHandler(event.target.value);
  };
  const onSubmitHandler = (event) => {
    event.preventDefault();
    props.onSubmit();
  };
  return (
    <Box>
      <form
        className={classes.searchRoot}
        onSubmit={(event) => onSubmitHandler(event)}>
        <FormControl fullWidth>
          <TextField
            id="searchBasic"
            variant="outlined"
            value={props.text}
            onChange={(event) => onChangeHandler(event)}
            placeholder="Search Users..."></TextField>
        </FormControl>
        <Constants.StyledButton
          fullWidth
          textcolor="#fff"
          bgcolor="#333"
          hovercolor="#444"
          onClick={props.onSubmit}
          className={classes.searchBtn}
          styletype="contained">
          SEARCH
        </Constants.StyledButton>
        {props.show && (
          <Constants.StyledButton
            fullWidth
            textcolor="#333"
            bgcolor="#ccc"
            hovercolor="#bbb"
            onClick={props.clearUsers}
            className={classes.searchBtn}
            styletype="contained">
            CLEAR
          </Constants.StyledButton>
        )}
      </form>
    </Box>
  );
};

export default Search;
